import InputSelectTable from './InputSelectTable'
import RangeInput from './RangeInput'
export { InputSelectTable,RangeInput }


// WEBPACK FOOTER //
// ./src/components/FormCustomItem/index.js